export type TabGroup = 'work' | 'people-assets' | 'business' | 'system';

export interface TabDef {
  id: string;
  label: string;
  description: string;
  group: TabGroup;
  icon?: string;
}

export interface TabGroupDef {
  id: TabGroup;
  label: string;
}

export const TAB_GROUPS: TabGroupDef[] = [
  { id: 'work', label: 'Work' },
  { id: 'people-assets', label: 'People & Assets' },
  { id: 'business', label: 'Business' },
  { id: 'system', label: 'System' },
];

export const TABS: TabDef[] = [
  // Work
  { id: 'overview',    label: 'Overview',    icon: '🧭', description: 'V2 rail status and dependency checks',              group: 'work' },
  { id: 'session',     label: 'Session',     icon: '🔐', description: 'Auth and session helper seam',                      group: 'work' },
  { id: 'ops',         label: 'Ops',         icon: '📡', description: 'Operational readout surface on the V2 rail',        group: 'work' },

  // People & Assets
  { id: 'daily-entry', label: 'Daily Entry', icon: '📋', description: 'First isolated daily-entry boundary on the V2 rail',group: 'people-assets' },
  { id: 'scheduler',   label: 'Scheduler',   icon: '📅', description: 'First isolated scheduler boundary on the V2 rail',  group: 'people-assets' },
  { id: 'directory',   label: 'Directory',   icon: '👥', description: 'First isolated directory boundary on the V2 rail',  group: 'people-assets' },
  { id: 'safety',      label: 'Safety',      icon: '🦺', description: 'Compliance/accountability surface on the V2 rail',  group: 'people-assets' },
  { id: 'fleet',       label: 'Fleet',       icon: '🚚', description: 'First isolated fleet boundary on the V2 rail',      group: 'people-assets' },
  { id: 'training',    label: 'Training',    icon: '🎓', description: 'Placeholder training/LMS surface on the V2 rail',   group: 'people-assets' },
  { id: 'activity',    label: 'Activity',    icon: '📰', description: 'Manager/operator readout surface on the V2 rail',   group: 'people-assets' },

  // Business
  { id: 'finance',     label: 'Finance',     icon: '💰', description: 'First isolated finance boundary on the V2 rail',    group: 'business' },
  { id: 'charts',      label: 'Charts',      icon: '📊', description: 'Package-managed charting proof',                    group: 'business' },

  // System
  { id: 'bug-trap',    label: 'Bug Trap',    icon: '🪲', description: 'First isolated Bug Trap boundary on the V2 rail',   group: 'system' },
  { id: 'settings',    label: 'Settings',    icon: '⚙️', description: 'Control surface on the V2 rail',                    group: 'system' },
];
